// src/utils/cart.js
import React from "react";
import currencyGreen from "../assets/images/currency_white_1.png";

export const ACCESSORY_FEE = 300;
export const OUTSIDE_RIYADH_SURCHARGE = 40;

/** Text-only formatter (use where a string is required) */
export const moneyText = (n) => `${Number(n || 0).toLocaleString("ar-EG")} ر.س`;

/** React element with currency icon — safe in a .js file (no JSX). */
export const money = (n, opts = {}) => {
  const { showIcon = false, iconSize = 20, className } = opts;
  const amt = Number(n || 0).toLocaleString("ar-EG");

  return React.createElement(
    "span",
    { className, dir: "rtl", style: { whiteSpace: "nowrap" } },
    amt,
    showIcon
      ? React.createElement("img", {
          src: currencyGreen,
          alt: "SAR",
          width: iconSize,
          height: iconSize,
          style: { marginInlineStart: 6, verticalAlign: "middle" },
        })
      : null
  );
};

/* Countries */
export const COUNTRIES = [
  { code: "SA", name: "السعودية" },
  { code: "AE", name: "الإمارات" },
  { code: "BH", name: "البحرين" },
];

/* Pick the best active offer (percent or fixed). */
export function pickBestOffer(base, offers = []) {
  let best = { finalPrice: Number(base || 0), discount: 0, offer: null };
  const b = Number(base || 0);
  (offers || [])
    .filter((o) => o?.is_active)
    .forEach((o) => {
      const type = (o.type || "").toLowerCase();
      const raw = Number(o.value || 0);
      let d = 0;
      if (type === "fixed") d = Math.max(0, Math.min(raw, b));
      else if (type === "percent") d = Math.max(0, Math.min((b * raw) / 100, b));
      const f = b - d;
      if (d > best.discount) best = { finalPrice: f, discount: d, offer: o };
    });
  return best;
}
